import React from 'react';

/**
 * Bar chart (outline). Path from Game Icons — bar chart via react-icons `GrBarChart` (CC BY 3.0).
 * https://game-icons.net/
 */
export default function NavTradeIcon({ className, ...rest }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <path d="M0,22 L24,22 M22,2 L18,2 L18,18 L22,18 L22,2 Z M6,6 L2,6 L2,18 L6,18 L6,6 Z M14,18 L10,18 L10,10 L14,10 L14,18 Z" />
    </svg>
  );
}
